import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import * as _ from 'lodash';

@Injectable()
export class LanguageService {

  supportedLanguages:string[] = ['nl', 'fr', 'en', 'raw'];

  constructor(private translateService:TranslateService) {
  }

  getSupportedLanguages():string[] {
    return this.supportedLanguages;
  }

  getCurrentLanguage():string {
    return this.translateService.currentLang;
  }

  getFirstExistingTranslation(obj):any {

    let returnedValue = '';

    _.forEach(this.supportedLanguages, langKey => {
      if (!returnedValue && !returnedValue.length && obj[langKey] && obj[langKey].length) {
        returnedValue = obj[langKey];
      }
    });

    return returnedValue;
  }
}
